import ApiService from '@/services/ApiService';

export default {
  start(startTotal) {
    return ApiService()
      .post('/shift/start', { startDrawerCash: startTotal });
  },

  end(data) {
    return ApiService()
      .post('/shift/end/0', ApiService().formData(data), true, 'multipart/form-data');
  },

  printCashCal(data) {
    return ApiService().post('/shift/end/1', data, true);
  },

  quickInfo(endDrawerCash) {
    return ApiService().get('/shift/info/' + endDrawerCash);
  },

  pusleDrawer() {
    return ApiService().get('/shift/pulse-cash-drawer');
  },
};
